import React, { useContext } from "react";
import { ThemeContext } from "styled-components";
import { Box } from "@bca/ui-library";

import StyledIcon from "../Interfaces/StyledIcon";

const TruckSvg: React.FunctionComponent<StyledIcon> = ({
  fill = "grey-blue",
  ...props
}) => {
  const theme = useContext(ThemeContext);
  const hexColor = theme.colors[fill] || fill;
  return (
    <Box {...props} color="black">
      <svg
        width="18"
        height="16"
        viewBox="0 0 18 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.55 10.8125H17.1V7.64844C17.1 7.29688 16.9313 6.91602 16.6781 6.65234L13.8938 3.75195C13.6406 3.48828 13.275 3.3125 12.9375 3.3125H11.7V1.90625C11.7 1.14453 11.0813 0.5 10.35 0.5H1.35C0.590625 0.5 0 1.14453 0 1.90625V11.2812C0 12.0723 0.590625 12.6875 1.35 12.6875H1.8C1.8 14.2402 3.00938 15.5 4.5 15.5C5.99063 15.5 7.2 14.2402 7.2 12.6875H10.8C10.8 14.2402 12.0094 15.5 13.5 15.5C14.9906 15.5 16.2 14.2402 16.2 12.6875H17.55C17.775 12.6875 18 12.4824 18 12.2188V11.2812C18 11.0469 17.775 10.8125 17.55 10.8125ZM4.5 14.0938C3.74063 14.0938 3.15 13.4785 3.15 12.6875C3.15 11.9258 3.74063 11.2812 4.5 11.2812C5.23125 11.2812 5.85 11.9258 5.85 12.6875C5.85 13.4785 5.23125 14.0938 4.5 14.0938ZM13.5 14.0938C12.7406 14.0938 12.15 13.4785 12.15 12.6875C12.15 11.9258 12.7406 11.2812 13.5 11.2812C14.2313 11.2812 14.85 11.9258 14.85 12.6875C14.85 13.4785 14.2313 14.0938 13.5 14.0938ZM15.75 8H11.7V4.71875H12.9375L15.75 7.64844V8Z"
          fill={hexColor}
        />
      </svg>
    </Box>
  );
};

export default TruckSvg;
